import type { NativeTimelineAppointment } from './appointmentActionSession';
import type { AdminAppointment } from './types';

export const RENDERABLE_ADMIN_LIFECYCLE_STATUSES = new Set<
  AdminAppointment['lifecycleStatus']
>(['scheduled', 'reschedule_pending', 'cancellation_pending']);

export const adminTimelineAppointment = (
  appointment: AdminAppointment,
  { readOnly = true }: { readOnly?: boolean } = {},
): NativeTimelineAppointment => ({
  actionCapabilities: {
    cancel: readOnly
      ? {
          allowed: false,
          reasonRequired: false,
          scopes: [],
        }
      : appointment.actionCapabilities.cancel,
    join: appointment.actionCapabilities.join,
    reschedule: readOnly
      ? {
          allowed: false,
          scopes: [],
        }
      : appointment.actionCapabilities.reschedule,
    viewHistory: appointment.actionCapabilities.viewHistory,
  },
  currentSchedule: appointment.currentSchedule,
  lifecycleStatus: appointment.lifecycleStatus,
  meeting: appointment.meeting,
  seriesId: appointment.seriesId,
  seriesMutationVersion: appointment.seriesMutationVersion,
  version: appointment.version,
});
